module.exports = __webpack_public_path__ + "static/media/orange.b38f8f49.svg";